export const HOUSE_RULES_TITLE = "House rules";

export const GENERAL_CHECK_IN_INSTRUCTIONS_TEXT =
  "Once you've completed your booking, keep an eye out for emails from your host. They will provide important information about your check-in process and address any questions you may have regarding the property or your stay.";

export const PAYMENT_POLICY_FULL_PAYMENT_DUE_NOW =
  "Full payment is due at the time of booking.";

export const PAYMENT_POLICY_CARD_ON_FILE =
  "If you cause damage to the property or incur incidental fees, your card may be charged.";

export const PAYMENT_POLICY_TITLE = "Payment policy";

export const REGISTRATION_NUM_TITLE = "Registration number";

export const CHECK_IN_INSTRUCTIONS_TITLE = "Check-in Instructions";
export const CHECK_IN_TIME_TITLE = "Check-in time";
export const CHECKOUT_TIME_TITLE = "Checkout time";
export const PETS_POLICY_TITLE = "Pets policy";
export const PETS_ALLOWED_TEXT = "Pets are allowed";
export const PETS_NOT_ALLOWED_TEXT = "Pets are not allowed";
